import axios from "axios";
import React, { useEffect } from "react";
import { replace, useNavigate } from "react-router-dom"; // Replaced Redirect with useHistory
import Cookie from "universal-cookie";
import config from "../config.js";

const Logout = () => {
  const cookies = new Cookie();
  const navigate = useNavigate(); // Hook for programmatic navigation

  // Safely retrieve cookies with fallback
  const userToken = cookies.get("userToken") || "";
  const userID = cookies.get("userID") || "";

  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    const logoutUser = async () => {
      try {
        // Remove all cookies
        const cookieOptions = {
          path: "/",
          secure: window.location.protocol === "https:",
        };
        cookies.remove("userID", cookieOptions);
        cookies.remove("userToken", cookieOptions);
        cookies.remove("userStatus", cookieOptions);
        cookies.remove("urname", cookieOptions);
        cookies.remove("uruser", cookieOptions);
        cookies.remove("uruserGroup", cookieOptions);
        cookies.remove("uruserDashboard", cookieOptions);
        cookies.remove("uralarm", cookieOptions);
        cookies.remove("urview", cookieOptions);
        cookies.remove("ursource", cookieOptions);
        cookies.remove("urrole", cookieOptions);
        cookies.remove("urdashboard", cookieOptions);
        cookies.remove("urreport", cookieOptions);

        // Determine logout endpoint based on userID
        const endpoint =
          userID === "99999" ? "/superuser/logout" : "/users/logout";
        await axios.post(
          `${config.BACKEND_URL}${endpoint}`,
          { userID },
          { headers }
        );

        // Navigate to home page using React Router
        navigate("/", { replace: true }); // Replaces current navigate entry
      } catch (err) {
        console.error(
          "Logout failed:",
          err.response?.data?.message || err.message
        );
        // Still navigate to home even if backend call fails, since cookies are cleared
        navigate("/", { replace: true });
      }
    };

    logoutUser();
  }, [navigate, userID, userToken]); // Dependencies for useEffect

  // No need for a return statement since navigation is handled in useEffect
  return null;
};

export default Logout;
